import {Exclude, Expose, Type} from 'class-transformer';
import {AbstractApiModel} from './abstract.api.model';
import {HyperlinkApiModel} from './hyperlink.api-model';
import {MediaObjectInterface} from '../../core/interfaces/media-object.interface';

@Exclude()
export class ChatAttachmentApiModel extends AbstractApiModel implements MediaObjectInterface {
  @Expose() public id: number | string;
  @Expose() public name: string;
  @Expose() public originalName: string;
  @Expose() public mimeType: string;
  @Expose() public size: string;
  @Expose() public dimensions: number[];
  @Expose() public type: string;
  @Expose() public createdAt: Date;
  @Expose() public updatedAt: Date;
  @Expose()
  @Type(() => HyperlinkApiModel)
  public hyperlinks: HyperlinkApiModel[];
}
